import {getRoles} from "../services/authService";

export function hasAdminRole() {
  const roles = getRoles();
  return roles?.some(role =>
    [
      'super_admin',
      'dmf_backoffice',
      'dmf_sales',
      'dmf_admin',
      'dmf_robot_sales',
      'dmf_robot_backoffice',
    ].includes(role.key)
  );
}
